import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { DateUtilsService } from '../../services/date-utils.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";
import { LoadingController, AlertController, NavController, IonModal, ModalController, IonContent } from '@ionic/angular';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Capacitor } from '@capacitor/core';
import { environment } from './../../../environments/environment';
import { ActivatedRoute } from '@angular/router';
import { NgxCroppedEvent } from '../../component/ngx-photo-editor/ngx-photo-editor.component';
import { FileCameraComponent } from '../../component/file-camera/file-camera.component';
import { DataURIToBlob, blobToBase64 } from '../../utils'
import { UserService } from '../../services/user.service';
import { User } from '../../models/user';
import { ChatMessage } from '../../models/ia';
import { Animal, AnimalWeight, AnimalVaccineValence, AnimalVaccine } from '../../models/animal';
import { NetworkService } from '../../services/network.service';
import { AnimalService } from '../../services/animal.service';
import { VaccineService } from '../../services/vaccine.service';
import { IaService } from '../../services/ia.service';
import { VaccineLabel } from '../../models/vaccine';
import { Location } from '@angular/common';
import { ClinicContact } from '../../models/clinic';
import { ClinicService } from '../../services/clinic.service';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { SpeechRecognition } from "@capacitor-community/speech-recognition";
import { TextToSpeech } from '@capacitor-community/text-to-speech';

@Component({
  selector: 'report-abuse',
  templateUrl: './report-abuse.component.html',
  styleUrls: ['./report-abuse.component.scss'],
  imports: [CommonModule, IonicModule, TranslateModule, FormsModule, ReactiveFormsModule,],
})
export class ReportAbuseComponent  implements OnInit {
  @ViewChild('modalReportAbuse', { static: false }) modalReportAbuse!: IonModal;

  loading: HTMLIonLoadingElement | null = null;
  @Input() source: string | null = null;
  @Input() msg: string | null = null;

  constructor(
    public http: HttpClient,
    public dateUtils: DateUtilsService,
    private authService: AuthService,
    private navCtrl: NavController,
    public loadingController: LoadingController,
    public translate: TranslateService,
    public fb: FormBuilder,
    public alertController: AlertController,
    private activatedRoute: ActivatedRoute,
    public userService: UserService,
    public networkService: NetworkService,
    public animalService: AnimalService,
    public vaccineService: VaccineService,
    public clinicService: ClinicService,
    public iaService: IaService,
    private location: Location,
    private modalController: ModalController,
    private router: Router) { }

  ngOnInit() {}

  present() {
    this.modalReportAbuse.present()
  }

  dismiss() {
    this.modalReportAbuse.dismiss()
  }

  async presentLoading() {
    if(this.loading)
      this.stopLoading();

    this.loading = await this.loadingController.create({
      cssClass: 'my-custom-class',
      message: this.translate.instant('Please wait...'),
      duration: 20000
    });
    await this.loading.present();
  }

  stopLoading() {
    this.loading?.dismiss();
    this.loading = null;
  }

  send() {
    let headers = new HttpHeaders({
      'Authorization': this.userService.getHttpHeaders()
    });
    let formData: { [key: string]: any } = {};
    formData["source"] = this.source;
    formData["msg"] = this.msg;

    this.http.post<any[]>(environment.API_URL + '../ws_public/ReportAbuse/', formData, {headers : headers}).subscribe({
      next: async (response: { [key: string]: any }) => {
        var alert = await this.alertController.create({
          header: this.translate.instant("Info"),
          subHeader: this.translate.instant("Report sent"),
          message: this.translate.instant("Thank you, we will process your report within a few days.") ,
          buttons: ['OK'],
        });
        await alert.present();
        this.dismiss()
      },
      error: async (error) => {
      }
    });
  }

}
